import RunAsSoonAs from "./RunAsSoonAs";
import AgentImageHandler from "./AgentImageHandler";

/**
 * This function will handle the image and agent title when the participant of chat changed
 * This function is being used by EP, DOM and windowed (Both RD and Standard)
 * @param participants
 */
const ParticipantsChanged = (participants, config) => {
    if (config && !config.isExitPopup) {
        const unique = {};
        const result = [];
        var i;
        for (i = 0; i < participants.length; i++) {
            const n = participants[i].displayName;

            if (participants[i].userId > 0 &&
                participants[i].userId == participants[i].currentlyAssigntoChat) {
                if (!unique[n]) {
                    unique[n] = true;
                    result.push(n);
                }
            }
        }
        RunAsSoonAs(
            () => {
                if ((result.length > 1 || config.participantsHasBeenGreaterThanOne) &&
                    !config.ended) {
                    config.hideWaitingIndicator(result.join(', '));
                }
            },
            () => typeof config.hideWaitingIndicator !== 'undefined'
        );
    }
    // update image
    const indicator = config.imageObjSelector;
    // get old url for comparison
    const prevUrl = indicator.attr('src');
    for (var i = 0; i < participants.length; i++) {
        // change image if operator joins for the first time
        if (participants[i].userId > 0 &&
            participants[i].userId == participants[i].currentlyAssigntoChat) {
            config.options.agentName = participants[i].displayName;
            if (config.isExitPopup) {
                const userTitle = config.userTitleSelector;
                userTitle[0].innerText = config.options.agentName;
            }
            if (prevUrl != participants[i].handlerImageUrl && participants[i].handlerImageUrl) {
                const imageUrl = participants[i].handlerImageUrl;
                indicator.attr('src', AgentImageHandler(imageUrl));
            }
            // if chat transferred or received on mobile device, get the agent name from the transferred participant.
            // if (participants[i].isTransferredChat || participants[i].isDeviceParticipant) {
            const headerText = config.$(config.options.participantsSelector);
            if (headerText && headerText.length > 0) {
                headerText[0].innerText = `Chat with: Visitor, ${config.options.agentName}`;
                config.participantsContainer = headerText;
                if (participants[i].handlerImageUrl && participants[i].handlerImageUrl != '') {
                    indicator.attr('src', AgentImageHandler(participants[i].handlerImageUrl));
                }
            }
        }
        // }
        // initialize the value of participant display name if it is not initalized
        if (!config.options.participantDisplayName) {
            config.options.participantDisplayName = participants[i].displayName;
        }
        if (config.options.model &&
            participants[i].userId > 0 &&
            participants[i].userId == participants[i].currentlyAssigntoChat) {
            config.options.model.agentName = participants[i].displayName;
        }
    }
    return config;
};
export default ParticipantsChanged;
